import { BaseLog, BaseLogArgs } from './BaseLog';
import { LEVEL } from './LEVEL';
import { REFRAME_EVENTS_STACK } from '../../devtools/StackMiddleware';

export const LOWERED_SEVERITY = [
    'ResizeObserver loop completed with undelivered notifications',
    'ResizeObserver loop limit exceeded',
    'Script error',
    'InvalidStateError',
    'UnknownError',
    'ChunkLoadError Loading chunk',
    'Error Loading CSS chunk',
    'Cannot resolve a DOM node from Slate node'
];

export function getUpdatedLogLevelBasedOnMessage(message, level) {
    if (LEVEL.ERROR === level) {
        try {
            for (const lowered of LOWERED_SEVERITY) {
                if (message?.toLowerCase().includes(lowered.toLowerCase())) {
                    return LEVEL.WARN;
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    return level;
}

interface JSErrorLogArgs extends Partial<BaseLogArgs> {
    component_stack?: string;
    extras?: Record<any, any>;
    boundary_description?: string;
}

export function JSErrorLog({
    message = '',
    stacktrace = '',
    component_stack = '',
    extras = {},
    boundary_description = '',
    level = LEVEL.ERROR
}: JSErrorLogArgs) {
    return BaseLog({
        category: 'JS_ERROR',
        message,
        data: {
            component_stack,
            reframe_stack: REFRAME_EVENTS_STACK,
            boundary_description,
            extras
        },
        level: getUpdatedLogLevelBasedOnMessage(message, level),
        stacktrace
    });
}
